export default [
    {
        key: "module",
        label: "Module",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "areas",
        label: "AREAS",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "tracking",
        label: "TRACKING",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "actions",
        label: "Actions",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    }
]